var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrusted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 28.5,
    r: 28.5,
    fill: "#F1F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1995 45.2269L27.8931 45.9719C28.1408 46.0809 28.4231 46.0815 28.6714 45.973L30.5763 45.1426L30.5779 45.1419C37.4084 42.2454 41.8497 35.4978 41.8504 28.0232V19.3811C41.8504 19.0208 41.6537 18.6873 41.3353 18.5162L28.7865 11.7665C28.4954 11.6097 28.1457 11.6119 27.8568 11.772L15.655 18.5218C15.3425 18.6949 15.1504 19.0247 15.1504 19.3811L15.1504 28.1985C15.1579 35.5833 19.4928 42.2667 26.1995 45.2269ZM29.7975 43.3452L29.8033 43.3423L29.814 43.3378C35.9224 40.7499 39.8995 34.7146 39.9009 28.0232V19.9683L28.3331 13.7462L27.9094 13.9806L27.8591 14.0084L17.0995 19.9609V28.198C17.1065 34.8073 20.9859 40.7839 26.9814 43.4302L27.8908 43.8306L28.2851 44.0043L28.621 43.8579L29.7975 43.3452Z",
    fill: "#2D2943"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9787 32.5882C26.6614 32.8714 26.1935 32.821 25.9326 32.4862L22.9272 28.6282C22.6688 28.2967 22.7021 27.8003 23.0089 27.5136M26.9787 32.5882L33.9781 26.3458C34.2916 26.0665 34.3352 25.5712 34.0845 25.2335C33.8273 24.8868 33.3504 24.8286 33.0271 25.117L26.5983 30.85L24.0688 27.6031C23.8031 27.2621 23.325 27.2178 23.0089 27.5136",
    fill: "#2D2943"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrusted);
export default __webpack_public_path__ + "static/media/trusted.99a9ccb9.svg";
export { ForwardRef as ReactComponent };